import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=1541c0cd&scoped=true"
import script from "./Merchants.vue?vue&type=script&lang=js"
export * from "./Merchants.vue?vue&type=script&lang=js"
import style0 from "./Merchants.vue?vue&type=style&index=0&id=1541c0cd&prod&scoped=true&lang=less"
import style1 from "./Merchants.vue?vue&type=style&index=1&id=1541c0cd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1541c0cd",
  null
  
)

export default component.exports